import { render, staticRenderFns } from "./Mobile-Data-Plan.vue?vue&type=template&id=1bd03537&scoped=true"
import script from "./Mobile-Data-Plan.vue?vue&type=script&lang=js"
export * from "./Mobile-Data-Plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd03537",
  null
  
)

export default component.exports